import { TextField } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import React from "react";
import './styles.scss'

const SearchBox = ({ label = '', value, onChange }) => {

    return (
        <TextField
            className="search-box"
            InputProps={{ startAdornment: (<Search style={{ color: '#656B70' }} />) }}
            fullWidth
            variant="outlined"
            value={value}
            onChange={onChange}
            placeholder={label || "Search"} />
    )
};

export default SearchBox;